<template>
    <modal size="large" @close="$emit('close')">
        <template #header>
            <span class="font-weight-bold" v-if="order && order.order_id">
                Order List For Order #{{ order.order_id }}
            </span>
        </template>
        <template #body>
			<div class="row">
				<div class="col-md-8">
					<div class="table-responsive">
						<table class="table table-hover">
							<thead>
								<tr>
									<!-- <th class="text-left">Order ID</th> -->
									<th class="text-left">Product</th>
									<!-- <th class="text-left">Customer Data</th> -->
									<th class="text-left">Qty</th>
									<!-- <th class="text-left">Price</th> -->
									<!-- <th class="text-left">Total Price</th> -->
								</tr>
							</thead>
							<tbody>
								<tr v-for="(order, i) in orders" :key="i">
									<!-- <td>
										<div class="d-flex flex-column">
											<span class="font-weight-bold">
												{{ getOrderDisplayId(order) }}
											</span>
										</div>
									</td> -->
									<td>
										<div class="d-flex">
											<span>{{ order.product_data.name }}</span>
										</div>
									</td>
									<!-- <td>
										<div class="d-flex flex-column">
											<span>{{ order.customer_data.name }}</span>
											<span>{{ order.customer_data.phone }}</span>
										</div>
									</td> -->
									<td>
										<div class="d-flex flex-column">
											<span>{{ getOrderQty(order) }}</span>
										</div>
									</td>
									<!-- <td>
										<div class="d-flex flex-column">
											<span>{{ getProductPrice(order) }}</span>
										</div>
									</td> -->
									<!-- <td>
										<div class="d-flex flex-column">
											<span>{{ getTotalPrice(order) }}</span>
										</div>
									</td> -->
								</tr>
							</tbody>
						</table>
					</div>

					<div
						class="list-empty table-empty text-center"
						v-if="orders.length === 0 && !isFetching"
					>
						<i class="material-icons mr-2">error_outline</i>
						<span>No Orders Found</span>
					</div>
				</div>
				<div class="col-md-4">
					<div class="card">
						<div class="card-body">
							<h5 class="card-title mb-3">Order Summary</h5>
							<div class="d-flex justify-content-between mb-2">
								<span>Total Product Price</span>
								<span>
									{{ formatMoney(totalProductPrice) }}
								</span>
							</div>
							<div class="d-flex justify-content-between mb-2">
								<span>Handling Fee</span>
								<span>
									{{ formatMoney(handlingFee) }}
								</span>
							</div>
							<div class="d-flex justify-content-between mb-2" v-if="!isSupplier">
								<span>Service Fee</span>
								<span>
									{{ formatMoney(serviceFee) }}
								</span>
							</div>
							<hr>
							<div class="d-flex justify-content-between font-weight-bold">
								<span>Total</span>
								<span>
									{{ formatMoney(totalPrice) }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Loader -->
			<div class="my-3 p-3 text-center" v-if="isFetching">
				<div class="is-loading dark large"></div>
			</div>

			<!-- Invoice Template (Hidden) -->
			<div v-if="invoiceHtml" id="invoice-template" class="invoice-print-container" v-html="invoiceHtml"></div>
        </template>
        <template #footer>
			<div class="d-flex justify-content-between w-100">
				<div>
					<button
						v-if="!isSupplier"
						class="btn btn-primary"
						:class="{ 'is-loading': isPrintLoad }"
						:disabled="isFetching || orders.length === 0"
						@click="downloadInvoice"
					>
						<i class="fi fi-rr-download mr-1"></i>
						Download Invoice
					</button>
				</div>
                <div>
                    <button class="btn btn-light" @click="$emit('close')">Close</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import dayjs from 'dayjs';
import { formatMoney, makePDF } from '@/lib/helper';
import Modal from '@/components/Modal.vue';
import {
	getList,
} from '@/api/private-order-items';

export default {
	name: 'OrderList',
	components: {
		Modal,
	},
	props: {
		order: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			isPrintLoad: false,
			isFetching: false,
			orders: [],
			invoiceHtml: '',
		};
	},
	computed: {
		...mapGetters({
			appLogo: 'appLogo',
			isAdmin: 'isAdmin',
			isOwner: 'isOwner',
			isSupplier: 'isSupplier',
			isDropshipper: 'isDropshipper',
			user: 'user',
		}),
		totalProductPrice() {
			const productPrice = this.order?.total_product_price || 0;
			const productCommissionFee = this.order?.product_commission_fee || 0;
			const total = productPrice + productCommissionFee;
			return total;
		},
		serviceFee() {
			// return this.order?.fee_config?.service_fee?.final_value || 0;
			return this.order?.service_fee || 0;
		},
		totalHandlingFee() {
			// return this.order?.fee_config?.handling_fee?.total_fee || 0;
			return this.order?.handling_fee || 0;
		},
		handlingFeeSupplier() {
			// return this.order?.fee_config?.handling_fee?.total_fee_supplier || 0;
			return this.order?.handling_fee || 0;
		},
		handlingFee() {
			let fee = 0;
			if (this.isSupplier) {
				fee = this.handlingFeeSupplier;
			} else {
				fee = this.totalHandlingFee;
			}
			return fee;
		},
		totalPrice() {
			let total = this.totalProductPrice;
			if (this.isSupplier) {
				total += this.handlingFeeSupplier;
			} else {
				total += this.serviceFee + this.totalHandlingFee;
			}
			return total;
		},
	},
	created() {
		this.fetchOrderList();
	},
	updated() {
		this.fetchOrderList();
	},
	methods: {
		formatMoney,
		fetchOrderList() {
			if (!this.order || !this.order.order_id) return;
			const params = {
				page: 1,
				limit: 100,
				orderId: this.order?.order_id,
			};
			this.isFetching = true;
			const callback = (res) => {
				const data = res?.data?.data;
				this.orders = data || [];
				// console.log('this.orders: ', this.orders);
				this.isFetching = false;
				// console.log('orders: ', this.order);
			};
			const err = (e) => {
				console.log(e);
				this.isFetching = false;
			};

			getList(params, callback, err);
		},
		getOrderDisplayId(order) {
			let orderId = '';
			if (!order) return '';
			if (order.marketplace_data) {
				orderId = order.marketplace_data.order_sn;
			}
			return orderId;
		},
		getOrderQty(order) {
			let qty = order?.quantity || 0;
			if (order?.marketplace_data) {
				qty = parseInt(order.marketplace_data.qty) || 1;
			}
			return qty;
		},
		getProductPrice(order) {
			let price = 0;
			if (!order) return price;
			const productPrice = order.product_price || 0;
			price = this.formatMoney(productPrice) || 0;
			return price;
		},
		getTotalPrice(order) {
			let price = 0;
			let qty = 1;
			if (!order) return price;
			if (order.marketplace_data) {
				qty = parseInt(order.marketplace_data.qty) || 1;
			}
			const totalProductPrice = qty * (order.product_price || 0);
			price = this.formatMoney(totalProductPrice) || 0;
			return price;
		},
		downloadInvoice() {
			if (!this.order || this.orders.length === 0) return;

			this.isPrintLoad = true;
			const printedAt = dayjs().format('DD-MM-YYYY HH:mm:ss');
			const orderId = this.order.order_id || '';
			let paymentStatus = this.order.payment_status || this.order.payment?.status || 'unpaid';
			paymentStatus = paymentStatus.toUpperCase();
			const isPaid = paymentStatus === 'PAID';
			const statusColor = isPaid ? '#28a745' : '#dc3545';
			const statusBg = isPaid ? '#e9f7ef' : '#fdf2f2';
			const sellerName = this.user.name || '-';
			const sellerEmail = this.user.email || '-';

			const productRows = this.orders.map((item, index) => {
				const name = item.product_data?.name || '-';
				const qty = this.getOrderQty(item);
				const price = item.product_price || 0;
				const total = qty * price;

				return `
					<tr>
						<td style="padding: 8px; border-bottom: 1px solid #eee;">${index + 1}</td>
						<td style="padding: 8px; border-bottom: 1px solid #eee;">${name}</td>
						<td style="padding: 8px; border-bottom: 1px solid #eee; text-align: center;">${qty}</td>
						<td style="padding: 8px; border-bottom: 1px solid #eee; text-align: right;">${this.formatMoney(price)}</td>
						<td style="padding: 8px; border-bottom: 1px solid #eee; text-align: right;">${this.formatMoney(total)}</td>
					</tr>
				`;
			}).join('');

			this.invoiceHtml = `
				<div style="padding: 40px; font-family: sans-serif; color: #333; background: #fff;">
					<div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 30px;">
						<div>
							<h1 style="margin: 0; color: #000; font-size: 28px;">INVOICE</h1>
							<div style="margin: 10px 0 0 0; display: inline-block; padding: 5px 15px; border: 1px solid ${statusColor}; background: ${statusBg}; border-radius: 8px; color: ${statusColor}; font-weight: bold; text-transform: uppercase;">
								${paymentStatus}
							</div>
						</div>
						<div style="text-align: right;">
							<div style="font-weight: bold; font-size: 18px; margin-bottom: 5px;">Invoice: #${orderId}</div>
							<p style="margin: 0; color: #666;">Tanggal: ${printedAt}</p>
						</div>
					</div>

					<div style="margin-bottom: 30px; padding: 20px; background: #f9f9f9; border-radius: 8px;">
						<h3 style="margin: 0 0 10px 0; font-size: 16px; color: #555; text-transform: uppercase;">Informasi Seller</h3>
						<p style="margin: 0; font-weight: bold; font-size: 16px;">${sellerName}</p>
						<p style="margin: 5px 0 0 0; color: #666;">${sellerEmail}</p>
					</div>

					<table style="width: 100%; border-collapse: collapse; margin-bottom: 30px;">
						<thead>
							<tr style="background: #eee;">
								<th style="padding: 10px; text-align: left; border-bottom: 2px solid #ddd;">No</th>
								<th style="padding: 10px; text-align: left; border-bottom: 2px solid #ddd;">Produk</th>
								<th style="padding: 10px; text-align: center; border-bottom: 2px solid #ddd;">Qty</th>
								<th style="padding: 10px; text-align: right; border-bottom: 2px solid #ddd;">Harga</th>
								<th style="padding: 10px; text-align: right; border-bottom: 2px solid #ddd;">Subtotal</th>
							</tr>
						</thead>
						<tbody>
							${productRows}
						</tbody>
					</table>

					<div style="display: flex; justify-content: flex-end;">
						<div style="width: 300px;">
							<div style="display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #eee;">
								<span>Total Harga Produk</span>
								<span>${this.formatMoney(this.totalProductPrice)}</span>
							</div>
							<div style="display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #eee;">
								<span>Handling Fee</span>
								<span>${this.formatMoney(this.handlingFee)}</span>
							</div>
							<div style="display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px solid #eee;">
								<span>Service Fee</span>
								<span>${this.formatMoney(this.serviceFee)}</span>
							</div>
							<div style="display: flex; justify-content: space-between; padding: 15px 0; font-weight: bold; font-size: 18px; color: #000;">
								<span>Total Pembayaran</span>
								<span>${this.formatMoney(this.totalPrice)}</span>
							</div>
						</div>
					</div>

					<div v-if="${isPaid}" style="margin-top: 50px; text-align: center; color: #999; font-size: 12px;">
						<p>Terima kasih atas transaksi Anda.</p>
						<p>Invoice ini diterbitkan secara otomatis oleh sistem OStock.</p>
					</div>
				</div>
			`;

			this.$nextTick(() => {
				try {
					const timestamp = new Date().getTime();
					const name = `Invoice-${orderId}-${timestamp}`;
					const callback = () => {
						this.isPrintLoad = false;
						this.invoiceHtml = '';
					};

					makePDF(document, 'invoice-template', html2canvas, jsPDF, name, callback);
				} catch (error) {
					console.log('error downloading invoice', error);
					this.isPrintLoad = false;
					this.invoiceHtml = '';
					this.$notify({
						group: 'app',
						type: 'error',
						title: 'Error',
						text: 'Gagal mendownload invoice. Silakan coba lagi.',
					});
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.invoice__copyright {
	margin-top: 1em;
	margin-bottom: .5em;
	color: #bbb;
	font-size: .9em;
	font-weight: bold;
	font-style: italic;
	text-align: center;

	span {
		display: inline-block;
		font-size: .9em;
		vertical-align: middle;
	}

	img {
		display: inline-block;
		margin-left: 1em;
		max-width: 125px;
		vertical-align: middle;
	}
}
.handover-print-container,
.invoice-print-container {
	position: fixed;
	top: -10000px;
	left: -10000px;
	width: 960px;
	background-color: #ffffff;
	color: #000000;
}
</style>
